import React, { FC, ReactNode } from 'react'
import classNames from 'classnames'
import { Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui/components/Tag'
import { Box, createStyles, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { Card } from 'transfix-ui'

interface IBookableShipmentSavedSearchTileProps {
  header: ReactNode
  countStr: string
  onClick: () => void
  isLoading: boolean
  dataTest: string
  variant?: 'mobile' | 'desktop'
}

const useStyles = makeStyles(theme => {
  return createStyles({
    tile: {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      boxSizing: 'border-box',
      '&:hover': {
        backgroundColor: brandColors.coolGray1,
        cursor: 'pointer',
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    tileHeaderContianer: {
      width: '100%',
    },
  })
})

export const BookableShipmentSavedSearchTile: FC<IBookableShipmentSavedSearchTileProps> = ({
  countStr,
  dataTest,
  header,
  isLoading,
  onClick,
  variant,
}) => {
  const classes = useStyles({ hasCount: !!countStr })
  const { isMobile } = useBreakpointContext()
  const mobileVersion = variant === 'mobile' && isMobile

  const tileHeaderContianer = classNames({
    [classes.tileHeaderContianer]: mobileVersion,
    [classes.container]: !mobileVersion,
  })

  return (
    <Box data-test={dataTest} onClick={onClick}>
      <Card className={classes.tile}>
        <Box className={tileHeaderContianer}>
          <Box>
            <Box>{header}</Box>
          </Box>
          <Box marginLeft='auto'>
            {!isLoading && !!countStr && (
              <Tag
                dataTest={`${dataTest}-count`}
                label={countStr}
                size={TAG_SIZE.small}
                tagStyle={TAG_STYLE.info}
              />
            )}
          </Box>
        </Box>
      </Card>
    </Box>
  )
}
